export default __webpack_public_path__ + "static/media/logo_header_small.a2de67cd.png";